import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const ProductGenerationRuleFieldsSchema_ = z.object({
  discountModifier: z.string(),
  productTitleSuffix: z.string(),
  skuSuffix: z.string(),
});

export const ProductGenerationRuleFieldsSchema: z.ZodType<ProductGenerationRuleFields> =
  ProductGenerationRuleFieldsSchema_;
export interface ProductGenerationRuleFields extends z.infer<
  typeof ProductGenerationRuleFieldsSchema_
> {}

export const getProductGenerationRule = unaryRpc({
  name: "getProductGenerationRule" as const,
  input: z.object({}),
  output: z.object({
    hasConnectedAccounts: z.boolean(),
    connectedAccountName: z.string().nullable(),
    rule: ProductGenerationRuleFieldsSchema.nullable(),
  }),
});

export const upsertProductGenerationRule = unaryRpc({
  name: "upsertProductGenerationRule" as const,
  input: ProductGenerationRuleFieldsSchema_,
  output: z.object({ rule: ProductGenerationRuleFieldsSchema }),
  mock: (_generated, input) => ({ rule: input }),
});
